module.exports = __webpack_public_path__ + "static/media/Bogen_2.c38f6738.png";